import React from "react";

function CtaButton({ action, actionData, text, busy }) {
  if (busy)
    return (
      <a className={`btn btn-cta float-end busy`} type="submit">
        <div className="btn-cta-overlay"></div>
        {text}
      </a>
    );

  return (
    <a className={`btn btn-cta float-end`} type="submit" onClick={action}>
      <div className="btn-cta-overlay"></div>
      {text}
    </a>
  );
}

export default CtaButton;
